"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.page-sublead {\n  text-align: left;\n  width: 100%; }\n\n.page-sublead-container {\n  padding-left: 16px;\n  padding-right: 24px;\n  padding-bottom: 24px; }\n\n@media (max-width: 66rem) {\n  .page-sublead-container {\n    padding-right: 24px; } }\n\n@media (max-width: 42rem) {\n  .page-sublead-container {\n    padding-right: 32px; } }\n";
  const fileName = "PageSubLead_PageSubLead";
  const element = document.querySelector("style[data-sass-component='PageSubLead_PageSubLead']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PageSubLead = _ref => {
  let {
    children,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-sublead-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "page-sublead sia-text-10"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    lang: lang
  }, children)));
};
PageSubLead.protoTypes = {
  lang: _propTypes.default.string.isRequired
};
var _default = exports.default = PageSubLead;